import React, { useState } from 'react';
import workerAPI from '../api/workerAPI';
import { FaUserAlt, FaLock, FaEye, FaEyeSlash } from 'react-icons/fa';
import { Link, useNavigate } from 'react-router-dom';
import Footer from './Footer';

const UserLogin = () => {
  const [loginData, setLoginData] = useState({ identifier: '', password: '' });
  const [showPassword, setShowPassword] = useState(false);
  const navigate = useNavigate();

  const handleChange = (e) => {
    const { name, value } = e.target;
    setLoginData({ ...loginData, [name]: value });
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    const { identifier, password } = loginData;

    try {
      const res = await workerAPI.post('/login', { identifier, password });

      localStorage.setItem('worker', JSON.stringify(res.data.worker));
      localStorage.setItem('token', res.data.token);

      alert(res.data.message || 'Login successful');

      const role = res.data.worker.role;

      if (role === 'Office') {
        navigate('/office-attendance');
      } else if (
        role === 'Developer' ||
        role === 'TL'        ||
        role === 'Designer'  ||
        role === 'Marketing'
      ) {
        navigate('/user-face');
      } else if (role === 'HR & Design') {
        navigate('/user-face');       // face attendance first, then sidebar guides them
      } else if (role === 'Project Leads') {
        navigate('/user-face');       // same pattern as TL
      } else {
        navigate('/');                // fallback
      }
    } catch (err) {
      alert(err.response?.data?.message || 'Login failed');
    }
  };

  return (
    <div className="min-h-screen flex items-center justify-center bg-gradient-to-br from-purple-200 via-white to-purple-300 p-4">
      {/* Back Button */}
      <button
        type="button"
        onClick={() => navigate(-1)}
        className="absolute top-4 left-4 flex items-center gap-2 text-purple-600 hover:text-purple-800 font-medium"
      >
        ← Back
      </button>

      <div className="bg-white rounded-2xl shadow-xl w-full max-w-md p-8 space-y-6">
        <div className="text-center mb-10">
          <h1 className="text-3xl font-extrabold text-purple-700 tracking-wide font-mono">
            User Login
          </h1>
        </div>

        <form onSubmit={handleSubmit} className="space-y-5">
          {/* Username or Email */}
          <div className="relative">
            <div className="absolute left-3 top-3 text-gray-400">
              <FaUserAlt />
            </div>
            <input
              type="text"
              name="identifier"
              id="identifier"
              required
              placeholder="Username or Email"
              onChange={handleChange}
              className="peer pl-10 h-12 w-full border-b-2 border-gray-300 text-gray-900 placeholder-transparent focus:outline-none focus:border-purple-600"
            />
            <label
              htmlFor="identifier"
              className="absolute left-10 -top-3.5 text-sm text-gray-600 transition-all peer-placeholder-shown:top-3 peer-placeholder-shown:text-base peer-placeholder-shown:text-gray-400 peer-focus:-top-3.5 peer-focus:text-sm peer-focus:text-purple-600"
            >
              Username or Email
            </label>
          </div>

          {/* Password */}
          <div className="relative">
            <div className="absolute left-3 top-3 text-gray-400">
              <FaLock />
            </div>
            <input
              type={showPassword ? 'text' : 'password'}
              name="password"
              id="password"
              placeholder="Password"
              required
              onChange={handleChange}
              className="peer pl-10 pr-10 h-12 w-full border-b-2 border-gray-300 text-gray-900 placeholder-transparent focus:outline-none focus:border-purple-600"
            />
            <label
              htmlFor="password"
              className="absolute left-10 -top-3.5 text-sm text-gray-600 transition-all peer-placeholder-shown:top-3 peer-placeholder-shown:text-base peer-placeholder-shown:text-gray-400 peer-focus:-top-3.5 peer-focus:text-sm peer-focus:text-purple-600"
            >
              Password
            </label>
            <div
              onClick={() => setShowPassword(!showPassword)}
              className="absolute right-3 top-3 cursor-pointer text-gray-400"
            >
              {showPassword ? <FaEyeSlash /> : <FaEye />}
            </div>
          </div>

          {/* Login Button */}
          <button
            type="submit"
            className="w-full bg-gradient-to-r from-purple-600 to-pink-600 text-white font-semibold py-3 rounded-lg hover:opacity-90 transition duration-300"
          >
            Login
          </button>
        </form>
      </div>
      <Footer />
    </div>
  );
};

export default UserLogin;